import React, { useEffect, useState } from "react";
import {
    Card,
    Typography,
    Row,
    Col,
    Divider,
    Space,
    Avatar,
    List,
    Tag,
    Button,
    Tooltip,
    message,
    Segmented,
    Dropdown,
    Menu,
    Flex,
} from "antd";
import {
    LikeOutlined,
    EyeOutlined,
    MessageOutlined,
    ArrowLeftOutlined,
    UserOutlined,
    LinkOutlined,
    LeftOutlined,
    DeleteOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    ClockCircleOutlined,
    ReloadOutlined,
    DownOutlined,
    FilterOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../../api";
import dayjs from "dayjs";
import RejectionModal from "../Approval/RejectionModal";

const { Title, Text, Paragraph } = Typography;

const ForumDetails = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [forumPosts, setForumPosts] = useState(null)
    const [selectedType, setSelectedType] = useState("Type");
    const [filterType, setFilterType] = useState("All");
    const [openRejectionModal, setOpenRejectionModal] = useState(false);
    const [openForumModal, setOpenForumModal] = useState(false);
    const [selectedPostId, setSelectedPostId] = useState(null);
    const [pendingAction, setPendingAction] = useState(null);
    const [pendingId, setPendingId] = useState(null);

    const [filteredData, setFilteredData] = useState([]);
    const [published, setPublished] = useState("All")
    const [messageApi, contextHolder] = message.useMessage();
    const forum = state?.forumData || {};

    const scrollDown = () => {
        window.scrollTo({
            top: 1100,
            behavior: "smooth",
        });
    };

    const getForumPosts = async () => {
        try {
            const requestData = {
                synceddatetime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
                FormCode: "201",
                AppVersion: "1.0.0.0",
                ApiKey: "kavin",
                fld_forum_id: forum?.fld_forum_id,
                AppTypeNo: "3",
            };

            
            const res = await api.getForumPostsApi(requestData);

            if (res?.data?.status === "1" && Array.isArray(res.data.post_forums_data)) {
                setForumPosts(res.data.post_forums_data);
                setFilteredData(res.data.post_forums_data)
            }
        } catch (err) {
            console.error("Error fetching forum posts:", err);
            messageApi.error("Failed to fetch forum posts");
        }


    }



    useEffect(() => {
        getForumPosts()

    }, [])


    const handleModalSubmit = async (reason) => {
        const status = pendingAction === "approve" ? 1 : 2;

        try {
            const res = await approveRejectPost(selectedPostId, status, reason);

            if (res?.status === "1") {
                messageApi.success(
                    status === 1 ? "Post Approved" : "Post Rejected"
                );
                getForumPosts();
            } else {
                messageApi.error(res?.message || "Failed");
            }
        } catch (err) {
            messageApi.error("Something went wrong");
        }

        // Close modal
        setOpenRejectionModal(false);
        setPendingAction(null);
        setSelectedPostId(null);
    };


    const approveRejectPost = async (postId, status, reason = "") => {
        try {
            const requestData = {
                synceddatetime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
                FormCode: "201",
                AppVersion: "1.0.0.0",
                ApiKey: "kavin",
                AppTypeNo: "3",
                fld_rf_id: postId,
                fld_is_approval_rejection_id: status,
                fld_is_approval_rejection_name: status === 1 ? "approved" : "rejected",
                fld_reason_for_rejection: reason,
            };



            const res = await api.approveRejectForumPost(requestData);

            return res?.data;
        } catch (err) {
            console.error("Approve/Reject error:", err);
            throw err;
        }
    };

    const openActionModal = (id, action) => {
       
        setPendingId(id);
        setPendingAction(action);
        setOpenForumModal(true);
    };





    const handleResetFilters = () => { }

    const handleSubmit = async () => {
        if (!pendingId || !pendingAction) return;

        try {
            if (pendingAction === "pin" || pendingAction === "unpin") {
                await handlePinForum(pendingId, pendingAction);
            }

            if (pendingAction === "close" || pendingAction === "open") {
                await handleCloseForum(pendingId, pendingAction);
            }

        } catch (error) {
            messageApi.error("Something went wrong");
        }
    };


    const handlePinForum = async (id, action) => {

        const payload = {
            "synceddatetime": "2025-05-29 10:08:00",
            "FormCode": "201",
            "AppVersion": "1.0.0.0",
            "ApiKey": "kavin",
            "AppTypeNo": "3",
            "fld_rf_id": id,
            "fld_pin_unpin_id": action === "pin" ? "1" : "0",
            "fld_pin_unpin_name": action === "pin" ? "pinned" : "unpinned"
        }
    
        try {
            const res = await api.pinForum(payload);
        
            if (res?.data?.status === "1") {
                if (action === "pin") {
                    messageApi.success("Forum Pinned Successfully")
                } else if (action === "unpin") {
                    messageApi.success("Forum UnPinned Successfully")
                
                }
                 setTimeout(() => {
                        navigate("/main/forum");
                    }, 2000);

            }

        } catch (err) {
            messageApi.error("Something went wrong");
        }
        setPendingId(null);
        setPendingAction(null);
        setOpenForumModal(false);

    }

    const handleCloseForum = async (id, action) => {
        try {

            const payload = {
                "synceddatetime": "2025-05-29 10:08:00",
                "FormCode": "201",
                "AppVersion": "1.0.0.0",
                "ApiKey": "kavin",
                "AppTypeNo": "3",
                "fld_rf_id": id,
                "fld_close_forum_id": action === 'close' ? "1" : "0",
                "fld_close_forum_name": action === 'close' ? "Inactive" : "active"

            }
            const res = await api.closeForum(payload);
            if (res?.data?.status === "1") {
                if (action === "open") {
                    messageApi.success("Forum Closed Successfully")
                } else if (action === "close") {
                    messageApi.success("Forum Opened Successfully")
                }
                  setTimeout(() => {
                        navigate("/main/forum");
                    }, 2000);
            }

        } catch (err) {
            messageApi.error("Something went wrong");
        }
        setPendingId(null);
        setPendingAction(null);
        setOpenForumModal(false);

    }

    const handleFilterTypeChange = (type) => {
        setFilterType(type)

        switch (type) {
            case "Approved":
                setFilteredData(forumPosts.filter((rep) => rep.fld_is_approval_rejection_id === "1"))
                break
            case "Rejected":
                setFilteredData(forumPosts.filter((rep) => rep.fld_is_approval_rejection_id === "2"))
                break
            case "Pending":
                setFilteredData(forumPosts.filter((rep) => rep.fld_is_approval_rejection_id === "0"))
                break
            case "All":
            default:
                setFilteredData(forumPosts);
                break;
        }
    }

    const publishMenu = (
        <Menu
            items={[
                {
                    key: "Published",
                    label: "Published",
                    onClick: () => {

                    },
                },
                {
                    key: "Unpublished",
                    label: "Unpublished",
                    onClick: () => {

                    },
                },
            ]}

        />
    )

    const typeMenu = (
        <Menu
            items={[
                {
                    key: "Online",
                    label: "Online",
                    onClick: () => {

                    },
                },
                {
                    key: "Offline",
                    label: "Offline",
                    onClick: () => {

                    },
                },
            ]}
        />
    );


    return (
        <div
            style={{
                background: "#f5f7fa",
                minHeight: "100vh",

            }}
        >
            {contextHolder}
            {/* Header with Back Button */}
            <div className="event-details-back-button-container">
                <Button
                    icon={<LeftOutlined />}
                    type="link"
                    onClick={() => navigate(-1)}
                    className="event-details-back-button"
                >
                    Back
                </Button>
            </div>

            {/* Forum Title + Banner */}
            <Card
                style={{
                    borderRadius: 16,
                    boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
                    padding: 0,
                }}
            >
                {forum.fld_cover_image_url && (
                    <img
                        src={forum.fld_cover_image_url}
                        alt="Forum Banner"
                        style={{
                            width: "100%",
                            height: 200,
                            objectFit: "cover",
                            borderTopLeftRadius: 16,
                            borderTopRightRadius: 16,
                        }}
                    />
                )}
                <Flex justify="flex-end">
                    <Space>
                        {forum.fld_pin_unpin_id === "1" ?
                            <Tooltip title="Unpin this forum">
                                <Button onClick={() => openActionModal(forum.fld_rf_id, "unpin")}>
                                    UnPin Forum
                                </Button>
                            </Tooltip>

                            :
                            <Tooltip title="Pin this forum">
                                <Button onClick={() => openActionModal(forum.fld_rf_id, "pin")}>
                                    Pin Forum
                                </Button>
                            </Tooltip>
                        }
                        {/* {forum.fld_close_forum_id === "1" ?
                            <Tooltip title="Open this forum">
                                <Button onClick={() => openActionModal(forum.fld_rf_id, "open")}>
                                    Open Forum
                                </Button>
                            </Tooltip>
                            :
                            <Tooltip title="Close this forum">
                                <Button onClick={() => openActionModal(forum.fld_rf_id, "close")}>
                                    Close Forum
                                </Button>
                            </Tooltip>
                        } */}
                    </Space>
                </Flex>
                <div style={{ padding: '20px' }}>
                    <div level={2} style={{ marginBottom: 8, fontSize: 25 }}>
                        {forum.fld_forum_title || "Untitled Forum"}
                    </div>
                    {/* <Text type="secondary">
            {forum.fld_category_name || "General"} •{" "}
            {forum.fld_thread_type_name || "Public Thread"}
          </Text> */}
                    <Paragraph style={{ marginTop: 16, fontSize: 15 }}>
                        {forum.fld_forum_description ||
                            "No description has been added for this forum."}
                    </Paragraph>

                    {/* Stats Section */}

                    <Space size="large">
                        <Space>
                            <LikeOutlined style={{ color: "#ff4d4f" }} />
                            <Text strong>{forum.fld_likes_count || 120}</Text> Likes
                        </Space>
                        <Tooltip title="View Replies" >
                            <Space onClick={scrollDown} style={{ cursor: 'pointer' }}>
                                <MessageOutlined style={{ color: "#52c41a" }} />
                                <Text strong>{forum.fld_replies_count || 20}</Text> Replies
                            </Space>
                        </Tooltip>
                        <Space>
                            <EyeOutlined style={{ color: "#1890ff" }} />
                            <Text strong>{forum.fld_views_count || 540}</Text> Views
                        </Space>
                    </Space>

                    <Divider />

                    <Row gutter={[24, 16]}>
                        <Col xs={24} md={12}>
                            <Text strong>Category Name:</Text>
                            <Paragraph>{forum.fld_category_name || "N/A"}</Paragraph>
                        </Col>
                        <Col xs={24} md={12}>
                            <Text strong>Category Description:</Text>
                            <Paragraph>{forum.fld_category_description || "N/A"}</Paragraph>
                        </Col>

                        <Col xs={24} md={12}>
                            <Text strong>Thread Type:</Text>
                            <Paragraph>{forum.fld_thread_type_name || "N/A"}</Paragraph>
                        </Col>
                        <Col xs={24} md={12}>
                            <Text strong>Thread Status:</Text>
                            <Paragraph>{forum.fld_threads_status_name || "N/A"}</Paragraph>
                        </Col>
                    </Row>

                    <Divider />
                    <Title level={5}>Announcement</Title>
                    <Card
                        style={{
                            background: "#fafafa",
                            borderRadius: 12,
                            border: "1px solid #eee",
                            marginTop: 8,
                        }}
                    >
                        <Text strong>{forum.fld_announcement_title || "No Announcement"}</Text>
                        <Paragraph type="secondary" style={{ marginTop: 4 }}>
                            {forum.fld_announcement_message || "No message provided."}
                        </Paragraph>
                    </Card>

                    <Divider />

                    {/* ⭐ Sponsors Section (Inserted AFTER Announcement and BEFORE Replies) */}
                    {forum.sponsors_data &&
                        forum.sponsors_data
                            .filter(
                                (sponsor) =>
                                    sponsor.fld_sponsors_name?.trim() !== "" &&
                                    sponsor.fld_sponsors_loge?.trim() !== ""
                            )
                            .length > 0 && (
                            <div style={{ marginTop: 30 }}>
                                <Title level={5}>Our Sponsors</Title>

                                <div className="event-details-sponsors-grid">
                                    {forum.sponsors_data
                                        .filter(
                                            (sponsor) =>
                                                sponsor.fld_sponsors_name?.trim() !== "" &&
                                                sponsor.fld_sponsors_loge?.trim() !== ""
                                        )
                                        .map((sponsor, index) => {
                                            const websiteUrl = sponsor.fld_website_url?.startsWith("http")
                                                ? sponsor.fld_website_url
                                                : `https://${sponsor.fld_website_url}`;

                                            return (
                                                <Tooltip key={index} title={websiteUrl} placement="top">
                                                    <a
                                                        href={websiteUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="event-details-sponsor-card-link"
                                                    >
                                                        <div className="event-details-sponsor-card">
                                                            <div className="event-details-sponsor-logo-wrapper">
                                                                <img
                                                                    src={sponsor.fld_sponsors_loge}
                                                                    alt={sponsor.fld_sponsors_name}
                                                                />
                                                            </div>

                                                            <span className="event-details-sponsor-name">
                                                                {sponsor.fld_sponsors_name}
                                                            </span>
                                                        </div>
                                                    </a>
                                                </Tooltip>
                                            );
                                        })}
                                </div>

                                <Divider />
                            </div>
                        )}

                    {/* Replies / Comments */}
                    {/* <div className="review-filters">
                        <div className="filter-buttons">
                            <Button icon={<FilterOutlined />} />

                            <Dropdown overlay={typeMenu} trigger={["click"]}>
                                <Button>
                                    {selectedType} <DownOutlined />
                                </Button>
                            </Dropdown>

                            <Dropdown overlay={publishMenu} trigger={["click"]}>
                                <Button>
                                    {published} <DownOutlined />
                                </Button>
                            </Dropdown>

                            <Button
                                icon={<ReloadOutlined />}
                                className="reset-btn"
                                onClick={handleResetFilters}
                            >
                                Reset Filter
                            </Button>
                        </div>

                        <Segmented
                            className="review-toggle"
                            options={["All", "Approved", "Rejected","Pending"]}
                            value={filterType}
                            onChange={handleFilterTypeChange}
                        />
                    </div> */}
                    <Segmented
                        className="review-toggle"
                        options={["All", "Approved", "Rejected", "Pending"]}
                        value={filterType}
                        onChange={handleFilterTypeChange}
                    />

                    <Title level={4}>Replies</Title>

                    <List
                        itemLayout="horizontal"
                        dataSource={filteredData || []}
                        pagination={{
                            pageSize: 5,
                            showSizeChanger: true,
                            pageSizeOptions: [5, 10],
                        }}
                        renderItem={(post) => (
                            <List.Item
                                style={{
                                    background: "#edeff1ff",
                                    borderRadius: 12,
                                    padding: 16,
                                    marginBottom: 12,
                                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                                }}
                                actions={[
                                    post?.fld_is_approval_rejection_id === "1" ? (
                                        <Space>
                                            <Tag color="green" icon={<CheckCircleOutlined />} style={{ fontWeight: 500 }}>
                                                Approved
                                            </Tag>

                                            {/* SHOW Reject button */}
                                            <Button
                                                type="primary"
                                                icon={<CloseCircleOutlined />}
                                                style={{
                                                    background: "linear-gradient(135deg, #FF7A7A, #FF4D4F)",
                                                    borderRadius: 8,
                                                    height: 25,
                                                    padding: "0 16px",
                                                    marginLeft: 8,
                                                }}
                                                onClick={() => {
                                                    setSelectedPostId(post.fld_rf_id);
                                                    setPendingAction("reject");
                                                    setOpenRejectionModal(true);
                                                }}

                                            >
                                                Reject
                                            </Button>
                                        </Space>
                                    ) : post?.fld_is_approval_rejection_id === "2" ? (
                                        <Space>
                                            <Tag color="red" icon={<CloseCircleOutlined />} style={{ fontWeight: 500 }}>
                                                Rejected
                                            </Tag>

                                            {/* SHOW Approve button */}
                                            <Button
                                                type="primary"
                                                icon={<CheckCircleOutlined />}
                                                style={{
                                                    background: "linear-gradient(135deg, #73E2A7, #52C41A)",
                                                    borderRadius: 8,
                                                    height: 25,
                                                    padding: "0 16px",
                                                    marginLeft: 8,
                                                }}
                                                onClick={() => {
                                                    setSelectedPostId(post.fld_rf_id);
                                                    setPendingAction("approve");
                                                    setOpenRejectionModal(true);
                                                }}

                                            >
                                                Approve
                                            </Button>
                                        </Space>
                                    ) : (
                                        <Space>
                                            <Tag color="orange" icon={<ClockCircleOutlined />} style={{ fontWeight: 500 }}>

                                                Pending
                                            </Tag>

                                            {/* BOTH BUTTONS */}
                                            <Button
                                                type="primary"
                                                icon={<CheckCircleOutlined />}
                                                style={{
                                                    background: "linear-gradient(135deg, #73E2A7, #52C41A)",
                                                    borderRadius: 8,
                                                    height: 25,
                                                    padding: "0 16px",
                                                    marginLeft: 8,
                                                }}
                                                onClick={() => {
                                                    setSelectedPostId(post.fld_rf_id);
                                                    setPendingAction("approve");
                                                    setOpenRejectionModal(true);
                                                }}
                                            >
                                                Approve
                                            </Button>

                                            <Button
                                                type="primary"
                                                icon={<CloseCircleOutlined />}
                                                style={{
                                                    background: "linear-gradient(135deg, #FF7A7A, #FF4D4F)",
                                                    borderRadius: 8,
                                                    height: 25,
                                                    padding: "0 16px",
                                                    marginLeft: 8,
                                                }}
                                                onClick={() => {
                                                    setSelectedPostId(post.fld_rf_id);
                                                    setPendingAction("reject");
                                                    setOpenRejectionModal(true);
                                                }}
                                            >
                                                Reject
                                            </Button>
                                        </Space>
                                    ),
                                ]}


                            >
                                <List.Item.Meta
                                    avatar={<Avatar icon={<UserOutlined />} />}
                                    title={
                                        <Space>
                                            <Text strong>{post.fld_post_title || "Anonymous"}</Text>
                                            <Text type="secondary" style={{ fontSize: 12 }}>
                                                {dayjs(post.fld_created_datetime).format("DD MMM YYYY")}
                                            </Text>
                                        </Space>
                                    }
                                    description={post.fld_post_body || "No content"}
                                />
                            </List.Item>
                        )}
                    />



                </div>
            </Card>

            {openRejectionModal && (
                <RejectionModal
                    title={pendingAction === "approve" ? "Approve Post" : "Reject Post"}
                    content={
                        pendingAction === "approve"
                            ? "Are you sure you want to approve this post?"
                            : "Are you sure you want to reject this post?"
                    }
                    buttonName={pendingAction === "approve" ? "Approve" : "Reject"}
                    open={openRejectionModal}
                    onClose={() => setOpenRejectionModal(false)}
                    onSubmit={handleModalSubmit}
                />
            )}

            {openForumModal === true && (
                <RejectionModal
                    title={
                        pendingAction === "pin" ? "Pin Forum" :
                            pendingAction === "unpin" ? "Unpin Forum" :
                                pendingAction === "close" ? "Close Forum" :
                                    "Open Forum"
                    }
                    content={
                        pendingAction === "pin"
                            ? "Are you sure you want to pin this forum?"
                            : pendingAction === "unpin"
                                ? "Are you sure you want to unpin this forum?"
                                : pendingAction === "close"
                                    ? "Are you sure you want to close this forum?"
                                    : "Are you sure you want to open this forum?"
                    }
                    buttonName={
                        pendingAction === "pin" ? "Pin" :
                            pendingAction === "unpin" ? "Unpin" :
                                pendingAction === "close" ? "Close" :
                                    "Open"
                    }
                    open={openForumModal}
                    onClose={() => setOpenForumModal(false)}
                    onSubmit={handleSubmit}
                />
            )}


        </div>
    );
};

export default ForumDetails;
